import { render, staticRenderFns } from "./BarCodeReaderListenerAlert.vue?vue&type=template&id=28ddf7ce&"
import script from "./BarCodeReaderListenerAlert.vue?vue&type=script&lang=ts&"
export * from "./BarCodeReaderListenerAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
